import axios from 'axios'
import type { ScheduledRunList, ScheduledRunTimeline, SchedulerOverview } from '@numeo/types'

const BASE = '/gluon/schedulers'

export const schedulersApi = {
    async overview(): Promise<SchedulerOverview> {
        const { data } = await axios.get<{ success: boolean; data: SchedulerOverview }>(`${BASE}/v1`)
        return data.data
    },

    async runs(job: string): Promise<ScheduledRunList> {
        const { data } = await axios.get<{ success: boolean; data: ScheduledRunList }>(`${BASE}/${encodeURIComponent(job)}/runs/v1`)
        return data.data
    },

    async timeline(hours: number): Promise<ScheduledRunTimeline> {
        const { data } = await axios.get<{ success: boolean; data: ScheduledRunTimeline }>(`${BASE}/timeline/v1`, { params: { hours } })
        return data.data
    },
}
